import { RoutesEnum } from '@/enums/routes.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { removeStorageItem } from '@/utils/localStorage';

import { useRefreshTokenMutation } from '../services/api.service';

import { useGamezone } from './useGamezone';
import { useJwt } from './useJwt';

export const clearAuthData = () => {
  // Do not remove refreshToken
  removeStorageItem(StorageKeysEnum.jwt);
  removeStorageItem(StorageKeysEnum.favourite_team_league_id);
  removeStorageItem(StorageKeysEnum.clientToken);
};

export const useLogout = () => {
  const { createGamezoneUrl } = useGamezone();
  const { setJwt, refreshToken, setRefreshToken } = useJwt();

  const [triggerRefreshToken] = useRefreshTokenMutation();

  const redirectToHome = () => {
    const homeUrl = createGamezoneUrl();
    window.location.assign(homeUrl);
  };

  const redirectToLogin = () => {
    const loginUrl = createGamezoneUrl({ pathname: RoutesEnum.login });
    window.location.assign(loginUrl);
  };
  const refreshAccessToken = async (props?: { onSuccess?: () => void }) => {
    const { onSuccess } = props || {};

    try {
      const refreshRes = await triggerRefreshToken({
        refreshToken: refreshToken,
      }).unwrap();
      setJwt(refreshRes.token);
      setRefreshToken(refreshRes.refresh_token);

      // Make submit
      onSuccess?.();
    } catch (error) {
      clearAuthData();
      redirectToLogin();
    }
  };

  return {
    clearAuthData,
    redirectToHome,
    redirectToLogin,
    refreshAccessToken,
  };
};
